/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { shiftWeekNames as i } from "../../utils.mjs";
class r {
  constructor(t) {
    this.intl = t;
  }
  getWeekNames(t = !1, e) {
    const s = i(
      this.intl.dateFormatNames({ nameType: e != null ? e : "short", type: "days" }),
      this.intl.firstDay()
    );
    return t ? [""].concat(s) : s;
  }
}
export {
  r as WeekNamesService
};
